import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'media-library-dialog',
  template: `
    <div class="header">
      <div class="title-wrap">
        <div class="title">Media library</div>
        <div class="subtitle">Upload, browse, and select an image asset.</div>
      </div>
      <button mat-icon-button aria-label="Close media library" (click)="close()">
          <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="body">
      <media-library mode="picker" (imageChosen)="imageChosen($event)" />
    </div>
  `,
  styles: `
    :host {
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .header {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
        padding: 10px 12px;
        border-bottom: 1px solid #e5e9f0;

        .title-wrap {
          min-width: 0;

          .title {
            color: #111827;
            font-size: 20px;
            font-weight: 700;
            line-height: 1.2;
          }

          .subtitle {
            margin-top: 4px;
            color: #64748b;
            font-size: 13px;
          }
        }
      }

      .body {
        flex: 1;
        min-height: 0;
        padding: 12px;
      }
    }
  `,
})
export class MediaLibraryDialog {
  constructor(private dialogRef: MatDialogRef<MediaLibraryDialog>) {}

  close() {
    this.dialogRef.close();
  }

  imageChosen(data) {
    this.dialogRef.close(data);
  }
}
